<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Alertas</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button type="button" class="btn btn-primary btn-sm mt-3" @click="OpenModalFilter()">
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{ countFilter }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Clientes</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 v-if="pagination.TotalItems > 0" class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                  <div class="dropdown m-0" v-if="pagination.TotalItems > 1">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <!-- <th scope="col" class="border-0"></th> -->
                    <th scope="col" class="border-0">Id</th>
                    <th scope="col" class="border-0">Data Alerta</th>
                    <th scope="col" class="border-0">Id Merchant</th>
                    <th scope="col" class="border-0">Merchant</th>
                    <th scope="col" class="border-0">Descrição</th>
                    <th scope="col" class="border-0">Resolvido Por</th>
                    <th scope="col" class="border-0">Data Resolução</th>
                    <th scope="col" class="border-0">Situação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(alertaMerchant, index) in listaAlertasMerchant" :key="index">
                    <td class="text">{{ alertaMerchant.Id }}</td>
                    <td class="text">{{ alertaMerchant.DataCriacao | date }}</td>
                    <td class="text">{{ alertaMerchant.Merchant.Id }}</td>
                    <td class="text">
                      {{ alertaMerchant.Merchant.Name }} - {{ alertaMerchant.Merchant.Identity | identity }}
                    </td>
                    <td class="text">{{ alertaMerchant.Descricao.length < 100 ?  alertaMerchant.Descricao : alertaMerchant.Descricao.slice(0,100) +"..." }}</td>
                    <td class="text">
                      {{ alertaMerchant.UsuarioResolucao.Id > 0 ? alertaMerchant.UsuarioResolucao.Nome : "-" }}
                    </td>
                    <td class="text">{{ alertaMerchant.DataResolucao | date("DD/MM/YYYY - HH:mm") }}</td>
                    <td class="text">
                      <b-button
                        variant="primary"
                        class="btn btn-light border border-secondary"
                        v-b-tooltip.hover.bottom
                        title="Visualizar"
                        @click="OpenModal(alertaMerchant)"
                      >
                        <i
                          v-bind:class="{
                            'fas fa-eye': alertaMerchant.UsuarioResolucao.Id > 0,
                            'fas fa-warning fa-red': alertaMerchant.UsuarioResolucao.Id <= 0,
                          }"
                        ></i>
                      </b-button>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      listaAlertasMerchant == undefined ||
                      listaAlertasMerchant == null ||
                      listaAlertasMerchant.length == 0
                    "
                  >
                    <td colspan="8">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="mFilter" title="Filtros" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
      <d-form-row>
        <d-col md="6" class="form-group">
          <input :placeholder="'Id Merchant'" type="text" class="form-control" v-model="filter.IdMerchant" />
        </d-col>
        <d-col md="6" class="form-group">
          <the-mask
            :placeholder="'Documento Merchant'"
            class="form-control"
            type="tel"
            :mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="filter.CNPJMerchant"
          />
        </d-col>
        <d-col md="12" class="form-group">
          <input :placeholder="'Nome Merchant'" type="text" class="form-control" v-model="filter.NomeMerchant" />
        </d-col>
        <d-col md="12" class="form-group">
          <input :placeholder="'Nome Sócio'" type="text" class="form-control" v-model="filter.NomeSocio" />
        </d-col>

        <d-col md="6" class="form-group">
          <label>Data Inicial</label>
          <date-field v-model="filter.DataCriacaoInicioFiltro" :maxDate="filter.DataCriacaoFimFiltro" />
        </d-col>

        <d-col md="6" class="form-group">
          <label>Data Final</label>
          <date-field v-model="filter.DataCriacaoFimFiltro" :minDate="filter.DataCriacaoInicioFiltro" />
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button variant="primary" class="btn btn-primary" v-b-tooltip.hover.bottom title="Pesquisar" @click="Filter()">
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="mVisualizarAlerta"
      title="Visualização do Alerta"
      size="lg"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <!-- Loader -->
      <div v-if="loadingModalVisualizarAlerta">
        <loader :is-loading="loadingModalVisualizarAlerta"></loader>
      </div>
      <div v-else>
        <ValidationObserver tag="form" ref="VisualizarAlertaForm">
          <d-form-row>
            <d-col md="3" class="form-group">
              <label>Data do cadastro</label>
              <d-form-input
                type="text"
                v-bind:value="alertaSelecionado.DataCriacao | date('DD/MM/YYYY - HH:mm')"
                readonly
              />
            </d-col>
            <d-col md="6" class="form-group">
              <label>Nome Merchant</label>
              <d-form-input type="text" v-model="alertaSelecionado.Merchant.Name" readonly />
            </d-col>
            <d-col md="3" class="form-group">
              <label>Documento Merchant</label>
              <the-mask
                class="form-control"
                type="text"
                :mask="['##.###.###/####-##']"
                v-model="alertaSelecionado.Merchant.Identity"
                readonly
              />
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Origem</label>
              <b-form-textarea
                type="text"
                rows="4"
                :class="validateAlertaMerchant | showValidateError(invalid)"
                :value="alertaSelecionado.Descricao"
                readonly
              />
            </d-col>
          </d-form-row>
          <d-form-row v-if="alertaSelecionado.IdResponsavelQsa != null">
            <d-col md="6" class="form-group">
              <label>CPF Responsável</label>
              <i
                v-b-tooltip.hover.bottom
                title="Caso o Responsável tenha sido encontrado na lista PEP o CPF deverá ser informado obrigatóriamente."
                class="fas fa-circle-info"
              ></i>
              <ValidationProvider rules="min:11|identity" v-slot="{ errors, invalid }">
                <the-mask
                  class="form-control"
                  :class="validateAlertaMerchant | showValidateError(invalid)"
                  type="text"
                  :mask="['###.###.###-##']"
                  v-model="alertaSelecionado.CPFResponsavel"
                  :disabled="bloquearInputCPF"
                />
                <div class="invalid-feedback d-block" v-if="validateAlertaMerchant">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>

          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Ação Tomada</label>
              <ValidationProvider rules="required|min:15|max:1000" v-slot="{ errors, invalid }">
                <b-form-textarea
                  type="text"
                  rows="4"
                  :class="validateAlertaMerchant | showValidateError(invalid)"
                  v-model="alertaSelecionado.AcaoTomada"
                  :disabled="EhAlertaResolvido()"
                />
                <div class="invalid-feedback d-block" v-if="validateAlertaMerchant">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
          <d-form-row v-if="EhAlertaResolvido()">
            <d-col md="6" class="form-group">
              <label>Usuario Ação</label>
              <d-form-input type="text" v-model="alertaSelecionado.UsuarioResolucao.Nome" readonly />
            </d-col>
            <d-col md="6" class="form-group">
              <label>Data da Ação</label>
              <d-form-input
                type="text"
                v-bind:value="alertaSelecionado.DataResolucao | date('DD/MM/YYYY - HH:mm')"
                readonly
              />
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          v-if="NaoEhAlertaResolvido()"
          size="sm"
          variant="success"
          @click="ValidateAlertaMerchant()"
          :disabled="loadingModalVisualizarAlerta"
        >
          <template v-if="!loadingModalVisualizarAlerta">
            Resolver Alerta
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingModalVisualizarAlerta"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../../utils/functions.js";
import dateField from "../../common/date-field";
export default {
  name: "compliance-alertas",
  components: {
    dateField,
  },
  data: function () {
    return {
      countFilter: 0,
      bloquearInputCPF: false,
      filter: {
        IdMerchant: null,
        NomeMerchant: null,
        NomeSocio: null,
        CnpjMerchant: null,
        DataCriacaoInicioFiltro: null,
        DataCriacaoFimFiltro: null,
      },
      loadingList: false,
      loadingReport: false,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0,
      },
      validateAlertaMerchant: false,
      listaAlertasMerchant: [],
      loadingModalVisualizarAlerta: false,
      alertaSelecionado: {
        Id: null,
        DataCriacao: null,
        DataResolucao: null,
        Descricao: null,
        Merchant: {
          Id: null,
          Name: null,
        },
        UsuarioResolucao: {
          Id: null,
          Nome: null,
        },
      },
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListAlertaMerchant();
    },
    "pagination.RowsPerPage": function () {
      this.ListAlertaMerchant();
    },
  },
  mounted() {
    this.ListAlertaMerchant();
  },
  methods: {
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    GetIdMerchantRootClass: function (idMerchantRoot) {
      return idMerchantRoot == 0 ? "fas fa-minus" : "";
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListAlertaMerchant();
    },
    OpenModal(alertaMerchant) {
      if (alertaMerchant != null && alertaMerchant.Id > 0) {
        this.validateAlertaMerchant = false;
        //variavel de controle para saber quando liberar ou nao o input do cpf do responsavel
        if (alertaMerchant.CPFResponsavel != null) {
          this.bloquearInputCPF = true;
        } else {
          this.bloquearInputCPF = false;
        }
        this.alertaSelecionado = null;
        this.loadingModalVisualizarAlerta = true;
        this.$bvModal.show("mVisualizarAlerta");
        this.alertaSelecionado = JSON.parse(JSON.stringify(alertaMerchant));
        this.loadingModalVisualizarAlerta = false;
      }
    },
    EhAlertaPep() {
      if (this.alertaSelecionado.Descricao != null) return this.alertaSelecionado.Descricao.indexOf("PEP") > -1;
      else return false;
    },
    EhAlertaResolvido() {
      return this.alertaSelecionado.UsuarioResolucao != null && this.alertaSelecionado.UsuarioResolucao.Nome != null;
    },
    NaoEhAlertaResolvido() {
      return this.alertaSelecionado.UsuarioResolucao == null || this.alertaSelecionado.UsuarioResolucao.Nome == null;
    },
    ValidateAlertaMerchant() {
      this.validateAlertaMerchant = true;
      this.$refs.VisualizarAlertaForm.validate().then((isValid) => {
        if (isValid) {
          this.validateAlertaMerchant = false;
          this.loadingModalVisualizarAlerta = true;

          this.$store
            .dispatch("ResolverAlerta", this.alertaSelecionado)
            .then((response) => {
              this.$makeToast("Alerta resolvido!", "info", "Liberação do alerta realizada com sucesso.");
              this.$bvModal.hide("mVisualizarAlerta");
              this.ListAlertaMerchant();
            })
            .catch((error) => {
              this.$makeToast(undefined, "danger", "Erro ao resolver alerta", error);
            })
            .finally(() => {
              this.loadingModalVisualizarAlerta = false;
            });
        }
      });
    },

    ListAlertaMerchant: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.IdMerchant)) this.countFilter++;
      if (hasValue(this.filter.NomeMerchant)) this.countFilter++;
      if (hasValue(this.filter.CNPJMerchant)) this.countFilter++;
      if (hasValue(this.filter.NomeSocio)) this.countFilter++;
      if (hasValue(this.filter.DataCriacaoInicioFiltro)) this.countFilter++;
      if (hasValue(this.filter.DataCriacaoFimFiltro)) this.countFilter++;

      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          Object: this.filter
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListAlertaMerchant", data)
        .then((response) => {
          this.listaAlertasMerchant = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao listar os clientes", error);
        })
        .finally(() => (this.loadingList = false));
    },
    ResetFilter: function () {
      (this.filter = {
        IdMerchant: null,
        NomeMerchant: null,
        NomeSocio: null,
        CnpjMerchant: null,
        DataCriacaoInicioFiltro: null,
        DataCriacaoFimFiltro: null,
      }),
        this.ListAlertaMerchant();
    },
  },
};
</script>

<style scoped>
.fa-red {
  color: #ff0000;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Compliance/AlertasMerchant.vue